module.exports = __webpack_public_path__ + "static/media/Deadlift_pic.26293212.jpg";